export default __webpack_public_path__ + "img/glp_blue-47a427fe1957a3beef477392ffad6e1a.png";